import { render, staticRenderFns } from "./basePlan.vue?vue&type=template&id=32177512&scoped=true&"
import script from "./basePlan.vue?vue&type=script&lang=ts&"
export * from "./basePlan.vue?vue&type=script&lang=ts&"
import style0 from "./basePlan.vue?vue&type=style&index=0&id=32177512&lang=scss&scoped=true&"
import style1 from "./basePlan.vue?vue&type=style&index=1&id=32177512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32177512",
  null
  
)

export default component.exports